export const hotkeysConfig = {
    enableModifiersForNumbers: false,
    enableHoverScroll: true,
    playPauseKey: (event, player) => {
        return event.which === 32 && player.settings().enablePlayPause;
    },
    rewindKey: (event, player) => {
        return event.which === 37 && player.settings().enableSeeking;
    },
    forwardKey: (event, player) => {
        return event.which === 39 && player.settings().enableSeeking;
    },
    fullscreenKey: (event, player) => {
        return event.which === 70 && player.settings().enableFullScreen;
    },
    customKeys: {
        cKey: {
            key: event => event.keyCode === 67,
            handler: (player, options, event) => {
                const captionsPlugin = player.captions?.();
                if (captionsPlugin) {
                    captionsPlugin.visible = !captionsPlugin.visible;
                }
            }
        }
    }
};
